module.exports = __webpack_public_path__ + "img/left.c546c3b3.png";